import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function Layout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const isAdmin = (user?.app_metadata?.role as string | undefined) === 'admin';

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <div className="brand">
          <span className="brand-logo" aria-hidden>
            {/* Amart-style red mark */}
            <svg viewBox="0 0 24 24" width="22" height="22">
              <path d="M12 3 4 9.5V21h5v-6h6v6h5V9.5z" fill="#fff" />
            </svg>
          </span>
          <span className="brand-text">
            Amart
            <small>Reporting Portal</small>
          </span>
        </div>

        <nav className="side-nav">
          <p className="nav-section">Overview</p>
          <NavLink to="/failed-deliveries">Failed deliveries</NavLink>
          <NavLink to="/difot">DIFOT</NavLink>
          <NavLink to="/driver-performance">Driver performance</NavLink>
          <NavLink to="/customer-feedback">Customer feedback</NavLink>

          <p className="nav-section">Cost</p>
          <NavLink to="/delivery-cost">Delivery cost</NavLink>

          {isAdmin && (
            <>
              <p className="nav-section">Team</p>
              <NavLink to="/invite">Users</NavLink>
            </>
          )}
        </nav>

        <div className="side-user">
          <span className="user-email" title={user?.email}>
            {user?.email}
          </span>
          <button type="button" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
